import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { AssetTypeDto } from '~/models/modules/Asset/assetType';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class AssetTypeService extends ApiServiceBase {

  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.assets);
  }

  getAssetTypeGrid(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
        .post<any[]>(this._url(`/grid-data`), model, {
            params,
            observe: 'response',
        })
        .pipe(map(augmentPaging));
  }


  createAssetType(model : any){
    return this.client.post<any>(this._url(), model);
  }


  // getAssetTypeListing(){
  //   return this.http.get<AssetTypeDto[]>(this._url());
  // }
  getAssetTypeListing(model: any = {}){
    return this.http.post<AssetTypeDto[]>(this._url(`/assetTypeListing`), model);
  }
  updateAssetType(id: number, model : any){
    return this.client.put<any>(this._url(`/${id}`), model);
  }


  getAssetTypeById(id : number){
    return this.http.get<AssetTypeDto>(this._url(`/${id}`));
  }

  deactivateAssetType(obj: any) {
    return this.client.put(this._url(`/deactivate`), obj);
  }

  deactivateAssetTypeBatch(obj: any) {
    return this.client.put(this._url(`/batchDeactivate`), obj);
  }

  reactivateAssetType(id: number) {
    return this.client.put(this._url(`/reactivate/${id}`), null);
  }
  reactivateAssetTypeBatch(obj: any) {
    return this.client.put(this._url(`/reactivate-batch`), obj);
  }


  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/AssetTypes${v}`);
  }
}
